export default "__VITE_ASSET__BAaBH_6Z__"